export var TRANSACTION_HISTORY = "TRANSACTION_HISTORY";
export var TRANSACTION_HISTORY_FILTER = "TRANSACTION_HISTORY_FILTER";
export var TRANSACTION_HISTORY_SEARCH = "TRANSACTION_HISTORY_SEARCH";
export var TRANSACTION_HISTORY_SORT = "TRANSACTION_HISTORY_SORT";
export var TRANSACTION_HISTORY_EDITABLE = "TRANSACTION_HISTORY_EDITABLE";
export var TRANSACTION_HISTORY_ALL_TXNS = "TRANSACTION_HISTORY_ALL_TXNS";
export var TRANSACTION_HISTORY_ALL_TXNS_LOADER = "TRANSACTION_HISTORY_ALL_TXNS_LOADER";
export var TRANSACTION_HISTORY_ALL_TXNS_ERROR = "TRANSACTION_HISTORY_ALL_TXNS_ERROR";
export var TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR = "TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR";
